<template>
  <div
    class="BaseSelect"
    :name="$attrs.name"
  >
    <!-- <p>{{ $attrs }}</p> -->
    <div class="select-content">
      <label :for="tag">{{ label }}</label>
      <select
        id=""
        v-model="innerValue"
        v-bind="inputAttributes"
      >
        <option
          class="placeholder"
          value=""
          selected
        >
          {{ $t('SELECTHOME.PLACEHOLDER') }}
        </option>
        <option
          v-for="(option, i) in options"
          :key="i"
          :value="i"
        >
          {{ option }}
        </option>
      </select>
    </div>

    <slot name="error" />
  </div>
</template>

<script>
import ModelMixin from '@/mixins/ModelMixin';

export default {
  mixins: [ModelMixin],

  // inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: undefined,
    },

    tag: {
      type: String,
      default: undefined,
    },

    options: {
      type: null,
      required: true,
      selected: '1',
    },
  },

  computed: {
    inputAttributes() {
      return Object.assign({}, this.$attrs);
    },
  },

  // created() {
  //   console.log(this.$attrs);
  // },
};
</script>


<style lang="scss" scoped>
.BaseSelect {
  width: 100%;
  .select-content {
    display: flex;
    align-items: center;
    width: 100%;
    label {
      margin-right: 1rem;
      @media #{$breakpoint-lg-max} {
        display: inline-block;
        width: 100px;
      }
    }
    select {
      border: solid 2px var(--color-primary);
      padding: 0.3rem 0.5rem;
      background: black;
      color: white;
      flex: 1 0 auto;

      outline: none;
      option[disabled] {
        color: #797979;
        background: #b3b3b3;
      }
    }
  }
}
</style>
